import { Component, OnInit } from "@angular/core";
import { GuestCreateprofileComponent } from "../guest-createprofile/guest-createprofile.component";
@Component({
  selector: "app-guest-editprofile",
  templateUrl: "../guest-createprofile/guest-createprofile.component.html",
  styleUrls: ["../guest-createprofile/guest-createprofile.component.scss"]
})
export class GuestEditprofileComponent extends GuestCreateprofileComponent
  implements OnInit {
  isEditMode = true;
  populateForm() {
    this.reservationformService.retrieveProfile().subscribe(
      (response: any) => {
        this.customer = response.customerProfile;
        this.form.patchValue({
          id: this.customer.id,
          fname: this.customer.fname,
          lname: this.customer.lname,
          mobileno: this.customer.main_profile.mobileno,
          email: this.customer.email,
          gender: this.customer.gender,
          fblink: this.customer.fblink
        });
        this.form.get("mobileno").disable({ emitEvent: false });
        this.form.controls["upincode"].setValidators([]);
        this.form.controls["upincode"].updateValueAndValidity();
        this.form.controls["cupincode"].setValidators([]);
        this.form.controls["cupincode"].updateValueAndValidity();
      },
      error => {
        this.customerauthService.handleHttpErrors(error);
      }
    );
  }

  save() {
    this.formSubmitted = true;
    if (!this.form.valid) {
      return;
    }
    this.loading = true;
    this.reservationformService.saveProfile(this.form.value).subscribe(
      (response: any) =>
      {
        this.loading = false;
            this.router.navigate(["guest/myprofile/"+this.formid]);
      },
      error => {
        this.loading = false;
        this.customerauthService.handleHttpErrors(error);
      }
    );
  }
}
